import axiosInstance from 'src/utils/axios';
import {
  CreateInvoiceQueryParams,
  CreatePurchaseByQuoteQueryParams,
  PurchaseByIdQuery,
  PurchaseByIdResponse,
  PurchaseReceiptQuery,
  StartPurchaseByQuoteData,
} from './types.api';

//
//

const EXTEND_URL = '/purchases/v1/';
const PURCHASE_BY_QUOTE_URL = EXTEND_URL + 'quote';

//

export const getPurchaseByIdAPI = async (
  query: PurchaseByIdQuery
): Promise<PurchaseByIdResponse> => {
  const { id, customerFullName } = query;

  const response = await axiosInstance.get<PurchaseByIdResponse>(
    `${EXTEND_URL}${id}${customerFullName ? '?fields=customerFullName' : ''}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//

export const startPurchaseByQuoteAPI = async (data: StartPurchaseByQuoteData) => {
  return axiosInstance.post(`${EXTEND_URL}quote/start`, data, {});
};

//

export const createPurchaseByQuoteAPI = async (data: CreatePurchaseByQuoteQueryParams) => {
  try {
    const response = await axiosInstance.post(PURCHASE_BY_QUOTE_URL, data, {});
    return response?.data;
  } catch (error) {
    console.error('Failed to make a purchase by quote:', error);
    throw error;
  }
};

export const createInvoiceRequestAPI = async (data: CreateInvoiceQueryParams) => {
  return axiosInstance.post(`${EXTEND_URL}invoice/quote`, data, {});
};

export const linkBusinessCustomerAPI = async ({
  purchaseId,
  businessCustomerId,
}: {
  purchaseId: string;
  businessCustomerId: string;
}) => {
  return axiosInstance.patch(
    `${EXTEND_URL}${purchaseId}`,
    JSON.stringify({ businessCustomerId: businessCustomerId })
  );
};

//

export const getBusinessCertificateAPI = async (query: PurchaseReceiptQuery) => {
  const { id } = query;

  const response = await axiosInstance.get(`pdf-certificate/business/${id}`, {
    responseType: 'blob',
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//

export const getCustomerCertificateAPI = async (query: PurchaseReceiptQuery) => {
  const { id } = query;

  const response = await axiosInstance.get(`pdf-certificate/customer/${id}`, {
    responseType: 'blob',
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//

export const getReceiptAPI = async (query: PurchaseReceiptQuery) => {
  const { id } = query;

  const response = await axiosInstance.get(`pdf-certificate/business/${id}/receipt`, {
    responseType: 'blob',
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
